<template>
  <div class="waitingMain">
    <!-- 顶部 -->
    <div class="top">
      <span class="title">待提交项目</span>
      <el-button
        round
        type="primary"
        @click="declarePro"
        style="margin-left: 70%;font-size: 16px;padding: 10px 20px"
        icon="el-icon-edit"
      >申报项目</el-button>
    </div>
    <!-- 表格部分 -->
    <el-table
      :data="tableData"
      :key="tableData.length"
      style="width:99%;"
      border
      stripe
      height="520"
    >
      <el-table-column prop="items_name" label="申报项目" align="center"></el-table-column>
      <el-table-column prop="now_award_type" label="申报类型" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.now_award_type === 0 ? '既有建筑初次申报' : '既有建筑升级申报'}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="company_name" label="申报单位" align="center"></el-table-column>
      <el-table-column prop="created_at" label="提交时间" align="center">
        <template slot-scope="scope">
          <p>{{moment(scope.row.created_at).format('YYYY-MM-DD HH:mm:ss')}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="状态" align="center">
        <template slot-scope="scope">
          <p>{{stateMap[scope.row.state]}}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="update(scope.row)" style="text-decoration:underline">修改资料</el-button>
          <el-button type="text" @click="delPro(scope.row)" style="text-decoration:underline">删除项目</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      layout="total,sizes,prev,pager,next,jumper"
    ></el-pagination>
  </div>
</template>

<script>
import moment from 'moment'
import { getUserInfo } from '../utils/cache'
import * as API from '../utils/apiService'
export default {
  data () {
    return {
      authority: '', // 申报权限（1 关闭申报 0 开放申报）
      stateMap: {
        1: '已提交',
        2: '已形审',
        3: '已初审',
        4: '已评审',
        5: '已评奖',
        6: '退回修改',
        7: '已公示',
        8: '已公告',
        9: '补充资料',
        10: '待提交'
      },
      moment,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted () {
    this.asyncQueryExistingbuildingByUseridWaiting()
    this.asyncQueryScheduleState()
  },
  methods: {
    // 删除项目
    delPro (item) {
      this.$confirm('确定删除该项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: item.id
        }
        API.deleteEBById(params).then(resp => {
          if (resp.resultCode === '0000') {
            this.$message.success('删除成功')
            this.asyncQueryExistingbuildingByUseridWaiting()
          }
        })
      })
    },
    // 待处理表格查询
    asyncQueryExistingbuildingByUseridWaiting () {
      let params = {
        userid: getUserInfo().id,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      API.queryExistingbuildingByUseridWaiting(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.tableData = resp.data.list
          this.total = resp.data.total
        }
      })
    },
    // 查询申报权限
    asyncQueryScheduleState () {
      API.queryScheduleState().then(resp => {
        if (resp.resultCode === '0000') {
          this.authority = resp.data
        }
      })
    },
    // 申报项目
    declarePro () {
      if (this.authority === '0') {
        this.$router.push('/primary?isUpdate=fasle')
      } else {
        this.$message.error('管理员未开发申报权限')
      }
    },
    // 修改资料
    update (item) {
      this.$router.push('/primary?isUpdateInfo=true&&id=' + item.id)
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.asyncQueryExistingbuildingByUseridWaiting()
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.asyncQueryExistingbuildingByUseridWaiting()
    }
  }
}
</script>

<style lang="scss">
.waitingMain {
  .el-dialog__header {
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
  }
  .el-dialog__title {
    color: #00b0f0;
  }
}
</style>
